import Cookies from 'cookies'
import { Request, Response } from 'express'
import JsCookies from 'js-cookie'

import { Appearance } from '../../@types'

const COOKIE_APPEARANCE = 'appearance'

export const getAppearance = (args?: {
  req: Request
  res: Response
}): Appearance => {
  let appearance
  let cookies
  if (args) {
    cookies = new Cookies(args.req, args.res)
  } else {
    cookies = JsCookies
  }
  try {
    appearance = JSON.parse(
      decodeURIComponent(cookies.get(COOKIE_APPEARANCE) || '{}'),
    )
  } catch (err) {
    logger.error('get appearance from cookie error', err)
  }

  return appearance
}

export const setAppearance = (
  appearance: Appearance,
  args?: { req: Request; res: Response },
): void => {
  let cookies
  if (args) {
    cookies = new Cookies(args.req, args.res)
  } else {
    cookies = JsCookies
  }
  try {
    cookies.set(COOKIE_APPEARANCE, JSON.stringify(appearance))
  } catch (err) {
    logger.error('set appearance into cookie error', err)
  }
}
